export enum LegalEntity {
  Mfb = 1,
  Tech = 2,
  MfbAndTech = 3,
}

export enum CustomerOnboardingType {
  Investment = 1,
  Borrower = 2,
  DigitalBank = 3,
  Aggregator = 4,
}
